import axios from 'lib/axios'

const url = (packageHashedId) => `/package_hook/${packageHashedId}/ny_1120b/registered_mail/tracking_number`

export const addTrackingNumber = (packageHashedId, roundNumber, trackingNumber) =>
  axios.post(url(packageHashedId), { round_number: roundNumber, tracking_number: trackingNumber })

export const removeTrackingNumber = (packageHashedId, roundNumber) =>
  axios.delete(url(packageHashedId), { params: { round_number: roundNumber } })
